import { render } from "./taxmodal.vue?vue&type=template&id=0de74664"
import script from "./taxmodal.vue?vue&type=script&lang=js"
export * from "./taxmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__